import { Callable } from "@renproject/utils";
import axios from "axios";
import { sortUTXOs, DEFAULT_TIMEOUT } from "./API";
export class BlockstreamClass {
    constructor({ testnet = false, apiKey = undefined } = {}) {
        this.getAPIUrl = (path) => `https://blockstream.info/${this.testnet ? "testnet/" : ""}api${path}${this.apiKey ? `?key=${this.apiKey}` : ""}`;
        this.fetchUTXO = async (txHash, vOut) => {
            const utxo = (await axios.get(this.getAPIUrl(`/tx/${txHash}`), {
                timeout: DEFAULT_TIMEOUT,
            })).data;
            const heightResponse = (await axios.get(this.getAPIUrl(`/blocks/tip/height`), {
                timeout: DEFAULT_TIMEOUT,
            })).data;
            const confirmations = utxo.status.confirmed
                ? Math.max(1 + parseInt(heightResponse, 10) - utxo.status.block_height, 0)
                : 0;
            return {
                txHash,
                amount: utxo.vout[vOut].value.toString(),
                vOut,
                confirmations,
            };
        };
        this.fetchUTXOs = async (address, confirmations = 0) => {
            const response = await axios.get(this.getAPIUrl(`/address/${address}/utxo`), { timeout: DEFAULT_TIMEOUT });
            const heightResponse = await axios.get(this.getAPIUrl(`/blocks/tip/height`), { timeout: DEFAULT_TIMEOUT });
            return response.data
                .map((utxo) => ({
                txHash: utxo.txid,
                amount: utxo.value.toString(),
                vOut: utxo.vout,
                confirmations: utxo.status.confirmed
                    ? 1 +
                        parseInt(heightResponse.data, 10) -
                        utxo.status.block_height
                    : 0,
            }))
                .filter((utxo) => confirmations === 0 || utxo.confirmations >= confirmations)
                .sort(sortUTXOs);
        };
        this.fetchTXs = async (address, confirmations = 0) => {
            const response = await axios.get(this.getAPIUrl(`/address/${address}/txs`), { timeout: DEFAULT_TIMEOUT });
            const heightResponse = await axios.get(this.getAPIUrl(`/blocks/tip/height`), { timeout: DEFAULT_TIMEOUT });
            const received = [];
            for (const tx of response.data) {
                for (let i = 0; i < tx.vout.length; i++) {
                    const vout = tx.vout[i];
                    if (vout.scriptpubkey_address === address) {
                        received.push({
                            txHash: tx.txid,
                            amount: vout.value.toString(),
                            vOut: i,
                            confirmations: tx.status.confirmed
                                ? 1 +
                                    parseInt(heightResponse.data, 10) -
                                    tx.status.block_height
                                : 0,
                        });
                    }
                }
            }
            return received
                .filter((utxo) => confirmations === 0 || utxo.confirmations >= confirmations)
                .sort(sortUTXOs);
        };
        this.broadcastTransaction = async (txHex) => {
            const response = await axios.post(this.getAPIUrl(`/tx`), txHex, {
                timeout: DEFAULT_TIMEOUT,
            });
            return response.data;
        };
        this.testnet = testnet;
        this.apiKey = apiKey;
    }
}
export const Blockstream = Callable(BlockstreamClass);
//# sourceMappingURL=blockstream.js.map